module.exports = __webpack_public_path__ + "static/media/link-count.13473a8b.svg";